/* MG SECTIONS — shared base JS (reveal on scroll) */
(function(){
  if (window.__mgRevealInit) return;
  window.__mgRevealInit = true;
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if (entry.isIntersecting){
        entry.target.classList.add('mg-in');
        io.unobserve(entry.target);
      }
    });
  }, {threshold:.12}) : null;

  function observeAll(){
    document.querySelectorAll('.mg-reveal:not(.mg-in)').forEach(function(el){
      if (io) { io.observe(el); } else { el.classList.add('mg-in'); }
    });
  }
  document.addEventListener('DOMContentLoaded', observeAll);
  document.addEventListener('shopify:section:load', observeAll);
})();

(function(){
  // Removes an entire bundle (all its constituent variants) in one action.
  // Uses event delegation on document rather than binding to the button
  // directly, since cart drawer/page content gets replaced wholesale via
  // innerHTML on every update — a direct listener would be lost the
  // moment the drawer re-renders after the very first change.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mg-bundle-remove]');
    if (!btn) return;
    e.preventDefault();

    var ids = btn.getAttribute('data-mg-bundle-remove').split(',').filter(Boolean);
    if (!ids.length) return;
    if (btn.disabled) return;

    var updates = {};
    ids.forEach(function (id) { updates[id] = 0; });

    // Was previously setting btn.textContent = 'Removing…' here, which
    // wipes out the button's SVG icon entirely (textContent replaces all
    // child nodes, icon included) — restoring it afterwards just set the
    // text back to an empty string, since the button's *original*
    // textContent was already blank (an SVG contributes no text). A CSS
    // class avoids touching the icon markup at all.
    btn.disabled = true;
    btn.classList.add('mg-is-removing');

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cartContainer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        if (cartContainer && typeof cartContainer.getSectionsToRender === 'function') {
          var sectionIds = cartContainer.getSectionsToRender().map(function (s) { return s.id; });
          fetch(window.location.pathname + '?sections=' + sectionIds.join(','))
            .then(function (r) { return r.json(); })
            .then(function (fresh) {
              try {
                cartContainer.renderContents({ id: null, sections: fresh });
                // Explicitly SET is-empty based on the real resulting
                // cart state, in both directions — Dawn's renderContents
                // only ever swaps inner content, never this class on the
                // outer element itself either way, regardless of which
                // direction the cart is changing. Previously this only
                // ever removed the class, which was correct for adding
                // (empty -> non-empty) but wrong here: removing the last
                // item leaves the cart genuinely empty, and unconditionally
                // stripping is-empty left the drawer in a broken layout
                // instead of showing its real empty state.
                var itemsEl = cartContainer.querySelector('cart-drawer-items');
                if (cart.item_count > 0) {
                  cartContainer.classList.remove('is-empty');
                  if (itemsEl) itemsEl.classList.remove('is-empty');
                } else {
                  cartContainer.classList.add('is-empty');
                  if (itemsEl) itemsEl.classList.add('is-empty');
                }
              } catch (err) {}
            })
            .catch(function () { window.location.reload(); });
        } else {
          // Full /cart page — not an AJAX-driven component, so a reload
          // is the simplest reliable way to reflect the change.
          window.location.reload();
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.classList.remove('mg-is-removing');
        alert('Could not remove this set. Please try again.');
      });
  });
})();